// extracted by mini-css-extract-plugin
export default {"backToTop":"BackToTop_backToTop__IuIP1","icon":"BackToTop_icon__mffaH"};